import {combineReducers} from 'redux';
import adminProfileReducer from './admin-profile';
import testsReducer from './tests';
import analysisCategoryReducer from './analysis-categories';
import labsReducer from './labs';
import usersReducer from './users';
import paymentsReducer from './payments';
import inquiriesReducer from './inquiries';

export default combineReducers({
   adminProfile: adminProfileReducer,
   testStore: testsReducer,
   analysisCategoryStore: analysisCategoryReducer,
   labStore: labsReducer,
   userStore: usersReducer,
   paymentStore: paymentsReducer,
   inquiryStore: inquiriesReducer,
})
